import produce from 'immer'
import config from '@config'
import {
  USER_SELECT_TYPE,
  USER_SELECT_CHILD,
  USER_SELECT_STORE,
  USER_SELECT_SLOT,
  USER_UPDATE_FORM,
  SET_ICS_FILE,
  SET_MARKETING_STATE
} from '@types'
import {MARKETING_STATE_FRESH} from "@names";

export const initialState = {
  mode: 'live',
  type: null,
  child: false,
  slot: null,
  store: null,
  form: {},
  marketing: MARKETING_STATE_FRESH,
  ics: false
}

export default (state = initialState, { type, payload } = {}) => {
  switch (type) {
    case USER_SELECT_TYPE:
      return produce(state, (s) => {

        s.store = config.get('local.store') || null
        s.slot = null
        s.type = payload
      })
    case USER_SELECT_CHILD:
      return produce(state, (s) => {
        s.child = payload
        if (payload) {
          s.mode = 'restricted'
        } else {
          s.mode = 'live'
        }
        s.store = null
        s.slot = null
      })
    case USER_SELECT_STORE:
      return produce(state, (s) => {
        s.store = payload
        s.slot = null
        if (s.mode === 'restricted') {
          return
        }
        if (!s?.store?.amparexId) {
          s.mode = 'restricted'
        } else {
          s.mode = 'live'
        }
      })

    case USER_SELECT_SLOT:
      return produce(state, (s) => {
        s.slot = payload
      })

    case USER_UPDATE_FORM:
      return produce(state, (s) => {
        s.form = payload
      })

    case SET_ICS_FILE:
      return produce(state, (s) => {
        s.ics = payload
      })

    case SET_MARKETING_STATE:
      return produce(state, (s) => {
        s.marketing = payload
      })

    default:
      return state
  }
}
